import React from 'react';
import PropTypes from 'prop-types';

import CancelButton from '../../formElements/CancelButton';
import TextAreaField from '../../formElements/TextAreaField';

import local from './styles/appointments.module.css';

const _NOTES_CHARACTER_LIMIT = 4000;
const _NEXT_NOTES_CHARACTER_LIMIT = 1000;

const NotesCurrent = ({
    initialStateEntry,
    notesCurrent,
    notesNext,
    onUpdateNotes,
    isDisabled,
    onClose
}) => {
    const resetFields = () => {
        onUpdateNotes('currentNotes', initialStateEntry?.notes || '');
        onUpdateNotes('nextAppointmentNotes', initialStateEntry?.nextAppointmentNotes || '');
    };

    const onCancel = () => {
        resetFields();
        onClose('notes');
    };
    return (
        <>
            <div className={local.componentSection} data-testid="notes_fields">
                <TextAreaField
                    id="currentNotes"
                    label="Notes from this Appointment"
                    maxLength={_NOTES_CHARACTER_LIMIT}
                    value={notesCurrent || ''}
                    count={`${notesCurrent?.length || 0}/${_NOTES_CHARACTER_LIMIT}`}
                    placeholder="Enter notes for this appointment"
                    disabled={isDisabled}
                    onChange={(e) => {
                        onUpdateNotes('currentNotes', e.target.value);
                    }}
                />
                <TextAreaField
                    id="nextAppointmentNotes"
                    label="Notes for next Appointment"
                    maxLength={_NEXT_NOTES_CHARACTER_LIMIT}
                    value={notesNext || ''}
                    count={`${notesNext?.length || 0}/${_NEXT_NOTES_CHARACTER_LIMIT}`}
                    placeholder="Enter notes for next appointment"
                    disabled={isDisabled}
                    onChange={(e) => {
                        onUpdateNotes('nextAppointmentNotes', e.target.value);
                    }}
                />
            </div>
            <CancelButton onClick={onCancel} />
        </>
    );
};

NotesCurrent.propTypes = {
    initialStateEntry: PropTypes.object,
    notesCurrent: PropTypes.string,
    notesNext: PropTypes.string,
    onUpdateNotes: PropTypes.func,
    isDisabled: PropTypes.bool,
    onClose: PropTypes.func
};

export default NotesCurrent;
